module.exports = __webpack_public_path__ + "static/media/mayuresh.ccedf65a.jpeg";